const TEAM_ALIASES = {
  'purdue-fort-wayne': 'ipfw',
  'fort-wayne': 'ipfw',
  'texas-at-arlington': 'texas-arlington',
  'ut-arlington': 'texas-arlington',
  'uta': 'texas-arlington',
  'uiw': 'incarnate-word',
  'southern-indiana': 'southern-ind',
  'grambling-st': 'grambling',
  'grambling-state': 'grambling',
  'southern': 'southern-u',
  'southern-university': 'southern-u',
  'app-state': 'appalachian-st',
  'app-st': 'appalachian-st',
  'appalachian-state': 'appalachian-st',
  'appalachian-st': 'appalachian-st',
  'iowa-state': 'iowa-st',
  'iowa-st': 'iowa-st',
  'little-rock': 'little-rock',
  ualr: 'little-rock',
  'miami-fla': 'miami-fl',
  'miami-florida': 'miami-fl',
  'miami-fl': 'miami-fl',
  'northern-illinois': 'northern-ill',
  'northern-illinois-university': 'northern-ill',
  'northern-ill': 'northern-ill',
  niu: 'northern-ill',
  'penn-state': 'penn-st',
  'penn-st': 'penn-st',
  'southern-california': 'southern-california',
  usc: 'southern-california',
  'southern-cal': 'southern-california',
  'texas-a-and-m': 'texas-am',
  'texas-am': 'texas-am',
};

const CANONICAL_NAMES = {
  'texas-arlington': 'UT Arlington',
  'incarnate-word': 'UIW',
  'appalachian-st': 'App State',
  'iowa-st': 'Iowa State',
  'little-rock': 'Little Rock',
  'miami-fl': 'Miami (FL)',
  'northern-ill': 'Northern Illinois',
  'penn-st': 'Penn State',
  'southern-california': 'USC',
  'texas-am': 'Texas A&M',
};

const CONFERENCE_ALIASES = {
  acc: 'ACC',
  'america-east': 'America East',
  americaeast: 'America East',
  american: 'American',
  'american-athletic': 'American',
  'atlantic-10': 'Atlantic 10',
  'atlantic-sun': 'ASUN',
  asun: 'ASUN',
  'big-12': 'Big 12',
  'big-east': 'Big East',
  'big-sky': 'Big Sky',
  'big-south': 'Big South',
  'big-ten': 'Big Ten',
  bigten: 'Big Ten',
  'big-west': 'Big West',
  caa: 'CAA',
  cusa: 'Conference USA',
  'conference-usa': 'Conference USA',
  horizon: 'Horizon',
  ivy: 'Ivy League',
  'ivy-league': 'Ivy League',
  maac: 'MAAC',
  metro: 'MAAC',
  mac: 'MAC',
  meac: 'MEAC',
  'mid-american': 'MAC',
  'missouri-valley': 'MVC',
  mountainwest: 'Mountain West',
  'mountain-west': 'Mountain West',
  mvc: 'MVC',
  northeast: 'NEC',
  nec: 'NEC',
  ovc: 'OVC',
  patriot: 'Patriot',
  'patriot-league': 'Patriot',
  sec: 'SEC',
  socon: 'SoCon',
  southern: 'SoCon',
  'southern-conference': 'SoCon',
  'southland': 'Southland',
  'summit-league': 'Summit League',
  summit: 'Summit League',
  'sun-belt': 'Sun Belt',
  swac: 'SWAC',
  uac: 'UAC',
  'united-athletic': 'UAC',
  'western-athletic': 'WAC',
  wac: 'WAC',
  wcc: 'WCC',
};

const CURRENT_CONFERENCE_OVERRIDES = {
  'abilene-christian': 'UAC',
  'austin-peay': 'UAC',
  'northern-ill': 'Horizon',
  'central-ark': 'UAC',
  'central-arkansas': 'UAC',
  'eastern-ky': 'UAC',
  'eastern-kentucky': 'UAC',
  'little-rock': 'UAC',
  'north-ala': 'UAC',
  'north-alabama': 'UAC',
  'tarleton-st': 'UAC',
  'west-ga': 'UAC',
  'west-georgia': 'UAC',
  'texas-arlington': 'UAC',
  'incarnate-word': 'Southland',
};

const DIVISION_ONE_CONFERENCES = new Set([
  'ACC', 'America East', 'American', 'Atlantic 10', 'ASUN', 'Big 12', 'Big East',
  'Big Sky', 'Big South', 'Big Ten', 'Big West', 'CAA', 'Conference USA',
  'Horizon', 'Ivy League', 'MAAC', 'MAC', 'MEAC', 'Mountain West',
  'MVC', 'NEC', 'OVC', 'Pac-12', 'Patriot', 'SEC', 'SoCon', 'Southland',
  'Summit League', 'Sun Belt', 'SWAC', 'UAC', 'WAC', 'WCC',
]);

export function slugifyTeam(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\bstate\b/g, 'st')
    .replace(/\bsaint\b/g, 'st')
    .replace(/[.'’]/g, '')
    .replace(/\([^)]*\)/g, (match) => match.replace(/[^a-z0-9]/g, ''))
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-');
}

export function canonicalTeamSlug(value) {
  const slug = slugifyTeam(String(value || '').replace(/^team:/i, ''));
  return TEAM_ALIASES[slug] || slug;
}

export function canonicalTeamName(value, slug = '') {
  const canonicalSlug = canonicalTeamSlug(slug || value);
  return CANONICAL_NAMES[canonicalSlug] || String(value || '').trim();
}

export function canonicalTeamId(team = {}) {
  const explicit = String(team.canonicalId || team.teamId || team.id || '').trim();
  const slug = canonicalTeamSlug(
    team.slug || team.seo || team.seoname || team.name || team.longName
  );
  if (slug) return `team:${slug}`;
  if (/^ncaa:\d+$/.test(explicit)) return explicit;
  if (/^\d+$/.test(explicit)) return `ncaa:${explicit}`;
  return '';
}

export function normalizeConference(value, team = null) {
  const teamSlug = team
    ? canonicalTeamSlug(team.slug || team.name || team.longName)
    : '';
  if ((!team?.season || Number(team.season) === 2026) && teamSlug && CURRENT_CONFERENCE_OVERRIDES[teamSlug]) {
    return CURRENT_CONFERENCE_OVERRIDES[teamSlug];
  }

  const raw = String(value || '').trim();
  if (!raw) return '';
  const key = raw.toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\bconference\b/g, '')
    .replace(/\bleague\b/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return CONFERENCE_ALIASES[key] || raw.replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function isDivisionOneConference(value) {
  return DIVISION_ONE_CONFERENCES.has(normalizeConference(value));
}

export function normalizeTeamIdentity(team = {}) {
  const sourceName = String(team.name || team.shortName || team.longName || '').trim();
  const slug = canonicalTeamSlug(team.slug || team.seo || team.seoname || sourceName);
  const name = canonicalTeamName(sourceName, slug) || sourceName;
  const conference = normalizeConference(team.conference || team.conferenceSlug, {
    ...team,
    slug,
    name,
  });
  return {
    ...team,
    canonicalId: canonicalTeamId({ ...team, slug, name }),
    slug,
    name,
    conference,
  };
}

export const TEAM_IDENTITY_ALIASES = Object.freeze({ ...TEAM_ALIASES });
